<template>
  <div class="location">
    <nova-select
      :title="name | setText(title)"
      :label="'choose_language' | setText('Выберите язык')"
      :items="languages"
      class="m-b-2"
      v-model="val"
      @change="change"
    ></nova-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Locale",
  props: {
    value: {
      default: null,
    },
    name: {
      default: null,
    },
    title: {
      default: 'Локализация содержимого',
    },
  },
  data() {
    return {
      val:null
    };
  },
  created() {
    this.val = this.value;
  },
  methods: {
    change(e) {
        this.$emit("input", this.val);
    },
  },
  computed: {
    ...mapState(["languages"]),
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
